import React from "react";
import { useNavigate } from "react-router-dom";

import { IgButton, IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { SETTINGS_ROUTES } from "../../../../routes/routes";

export const ProfitGraphPlaceholder = () => {
  const navigate = useNavigate();
  return (
    <Grid
      container
      direction={"column"}
      alignItems={"center"}
      sx={{ marginTop: "85px" }}
      justifyContent={"center"}
      rowSpacing={2}
    >
      <Grid item sx={{ textAlign: "center" }}>
        <IgTypography
          sx={{
            fontWeight: 600,
            fontSize: "18px",
            lineHeight: "27px",
            textAlign: "center",
            letterSpacing: ".15px",
          }}
        >
          For a complete Profit Analysis upload <br /> a list with your Cost of
          Goods Sold
        </IgTypography>
      </Grid>
      <Grid item>
        <IgButton
          size={"small"}
          onClick={() => {
            navigate(SETTINGS_ROUTES.Settings, {
              state: { targetId: "cogs-management" },
            });
          }}
          variant={"contained"}
        >
          Upload COGS
        </IgButton>
      </Grid>
    </Grid>
  );
};
